<template>  
    <div>
        <b-table
            hover
            responsive
            select-mode="single"
            small
            :id="id"            
            :primary-key="primaryKey"
            :items="items"
            :fields="fields"            
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :tbody-tr-class="rowClass"
            @filtered="onFiltered"
            style="min-height: 130px;">

            <template v-slot:cell(actions)="row" style="width: 15px; right">
                <b-button v-show="onEdit !== null" variant="outline-warning" size="sm" title="Editar registro." class="mb-0" id="btn_edit" @click="onEdit(row.item)">
                    <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
                </b-button>
                <b-button v-show="onDeleteRegister !== null" variant="outline-danger" size="sm" title="Excluir registro." class="mb-0" id="btn_delete" @click="openModal(row.item)">
                    <b-icon icon="trash" aria-hidden="true"></b-icon>
                </b-button>                
            </template>        
        </b-table>
        <b-row>
            <b-col style="margin-left: 10px;margin-right: 10px;">
                <b-row cols="12" style="margin-left: 5px;margin-right: 5px;">
                    <b-col sm="6" md="4" lg="3" xl="2">
                    <label>Qtd. Total de Itens</label>
                    <b-input 
                        v-model="this.totalItens" 
                        disabled>
                    </b-input>
                </b-col>
                <b-col sm="6" md="8" lg="9" xl="10" style="float:rigth">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        align="right"
                        style="padding-top: 30px;">
                    </b-pagination>  
                </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-modal
            :id="'delete_register_'+this.id"
            title="Exclusão de registro"
            header-bg-variant="danger">

            <h3>Confirma a exclusão do registro ?</h3>
            <template v-slot:modal-footer>
                <div style="padding: 0 5px 0 0">
                    <b-button variant="danger" @click="onDelete" id="btn_confirm"> Sim </b-button>
                </div>
                <div>
                    <b-button variant="primary" @click="onCancel" id="btn_cancel"> Não </b-button>
                </div>
            </template>
        </b-modal>
    </div>        
</template>

<script>

export default {
    name: 'BasicTable',
    
    props: {
        id: String,
        primaryKey: String,
        items: Array,
        fields: Array,
        filterOn: Array,
        placeholder: String,
        onEdit: {
            type: Function,
            default: null,
        },
        onShowDetail: {
            type: Function,
            default: null,
        },
        onDeleteRegister: {
            type: Function,
            default: null,
        },
        perPage: {
            type: Number,
            default: 10
        },
        rowClass: Function,

        totalItens: {
            type: Number,
            require: true,
            default: 0
        }
    },

    data() {
        return {
            search: "",
            filter: "",
            currentPage: 1,
            totalRows: 0,
            selected: [],            
        };
    },

    updated: function(){
        this.totalRows = this.items.length
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;                  
        },   

        onRowSelected(item) {            
            this.onEdit(item[0]);
        },

        openModal(item) {
            this.selected = item;
            this.$bvModal.show('delete_register_'+ this.id);
            
        },

        onDelete() {      
            this.onDeleteRegister(this.selected);
            this.$bvModal.hide('delete_register_'+ this.id);
        },

        openDetail(item) {
            this.onShowDetail(item[0]);
        },

        onCancel() {
            this.$bvModal.hide('delete_register_'+ this.id);   
        }
    },    
}
</script>